module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "title": "Contents"
    }
  }, [_c('p', {
    staticClass: "toc_h"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_vii",
      "title": "vii"
    }
  }, [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "tocf",
    attrs: {
      "id": "rack"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253053770_Acknowledgments"
    }
  }, [_c('i', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocf",
    attrs: {
      "id": "rabb"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253053770_Abbreviations"
    }
  }, [_c('i', [_vm._v("List of Abbreviations")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocf1",
    attrs: {
      "id": "rint"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253053770_Introduction#int"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "rch1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780253053770_Chapter_1#ch1"
    }
  }, [_vm._v("1"), _c('span', {
    staticClass: "tc"
  }, [_vm._v("Coming of Age in the Shadow of Colonialism, 1949–1966")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "rch2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253053770_Chapter_2#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2"), _c('span', {
    staticClass: "tc"
  }, [_vm._v("Education of a Revolutionary, 1966–1973")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "rch3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253053770_Chapter_3#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3"), _c('span', {
    staticClass: "tc"
  }, [_vm._v("A Rising Star: Soldiers and the Political Left, 1973–1982")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "rch4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253053770_Chapter_4#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4"), _c('span', {
    staticClass: "tc"
  }, [_vm._v("From Political Prisoner to Populist Prime Minister, 1982–1983")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "rch5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253053770_Chapter_5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5"), _c('span', {
    staticClass: "tc"
  }, [_vm._v("The “Revolution of August 4” and the People’s President")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "rch6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253053770_Chapter_6#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6"), _c('span', {
    staticClass: "tc"
  }, [_vm._v("“This Man Who Unsettles”: Confronting the Neocolonial Order, 1983–1984")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "rch7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253053770_Chapter_7#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7"), _c('span', {
    staticClass: "tc"
  }, [_vm._v("The Struggle for Unity, 1983–1984")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "rch8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253053770_Chapter_8#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8"), _c('span', {
    staticClass: "tc"
  }, [_vm._v("“Daring to Invent the Future”: Nation Building and the Promise of Revolutionary Change, 1984–1985")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc",
    attrs: {
      "id": "rch9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253053770_Chapter_9#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9"), _c('span', {
    staticClass: "tc"
  }, [_vm._v("Politics Is War and War Is Politics: Sankara in the International Arena, 1984–1985")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc1",
    attrs: {
      "id": "rch10"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_viii",
      "title": "viii"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253053770_Chapter_10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10"), _c('span', {
    staticClass: "tc"
  }, [_vm._v("Revolutionary Duties and Perils, 1986–1987")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tocc1",
    attrs: {
      "id": "rch11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253053770_Chapter_11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11"), _c('span', {
    staticClass: "tc"
  }, [_vm._v("No Turning Back: The Road to October 15, 1987")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocf",
    attrs: {
      "id": "rcon"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253053770_Conclusion#con",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "tocf1",
    attrs: {
      "id": "rbib"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253053770_Bibliography#bib",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Selected Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocf",
    attrs: {
      "id": "rind"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/9780253053770_Index#ind",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Index")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-027a9bf8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780253053770_Contents.vue
// module id = 69
// module chunks = 0